import { useState } from 'react';
import PropTypes from 'prop-types';
import { ModalGeneric } from 'ypf-pas-general-ui-components';

import './AssignProviderModal.scss';

const ConfirmAssignModal = (props) => {
  const {
    showModalAssign,
    setShowModalAssign,
    setIsChecked,
    assignProviderData,
    numero,
    proveedor,
    setMessage
  } = props;

  const [disabledAction, setDisabledAction] = useState(false);
  const closeModal = () => {
    setMessage('');
    setShowModalAssign(false);
    setIsChecked(null);
  };

  return (
    <ModalGeneric
      backdrop="static"
      disablePrimaryAction={disabledAction}
      infoModal
      onHide={() => closeModal()}
      primaryAction={() => {
        setDisabledAction(true);
        assignProviderData();
        setDisabledAction(false);
      }}
      primaryActionLabel="Aceptar"
      secondaryAction={() => {
        setDisabledAction(false);
        closeModal();
      }}
      secondaryActionLabel="Salir"
      show={showModalAssign}
      size="md"
      title="Asignar Solicitud de Servicio"
    >
      <div className="modal_body_confirm">
        ¿Querés asignar la Solicitud de Servicio
        <b>{` N° ${numero}`}</b> al proveedor <b>{proveedor}</b>?
      </div>
    </ModalGeneric>
  );
};

export default ConfirmAssignModal;

ConfirmAssignModal.propTypes = {
  showModalAssign: PropTypes.bool.isRequired,
  setShowModalAssign: PropTypes.func.isRequired,
  setIsChecked: PropTypes.PropTypes.func.isRequired,
  assignProviderData: PropTypes.func.isRequired,
  numero: PropTypes.string.isRequired,
  proveedor: PropTypes.string,
  setMessage: PropTypes.func
};

ConfirmAssignModal.defaultProps = {
  setMessage: () => {
    /* empty */
  },
  proveedor: ''
};
